import { FC } from 'react';

import LineClamp from 'components/misc/LineClamp';
import HoursDisplay from 'components/util/HoursDisplay';
import LinkWithOrigin from 'components/util/LinkWithOrigin';
import { getLinks } from 'pages/matters/util';
import { EffortListItem } from 'types/efforts';
import { getClassifierText } from 'utils/getTranslations';
import { getTextClampedToLinesProps } from 'utils/text';
import { useClassifiers } from 'utils/useClassifiers';

type Props = {
    effort: EffortListItem;
};

const USED_CLASSIFIERS = ['EFFORT_ACTIVITY_TYPE'];

const EffortList: FC<Props> = ({ effort }) => {
    const { classifiers } = useClassifiers({ codes: USED_CLASSIFIERS });
    const { id, effortActivityTypeCode, description, effortsByEmployees, usedTimeInSeconds } = effort;

    const employeeList = getLinks('employee', effortsByEmployees ?? []);

    return (
        <div className="w-full p-4">
            <div className="flex w-full items-center justify-between gap-2">
                <div className="overflow-hidden">
                    <LinkWithOrigin
                        to={`/effort/${id}`}
                        className="text-fg hover:text-link inline-block w-fit font-semibold whitespace-normal no-underline hover:underline"
                    >
                        <p className="text-body1 font-semibold whitespace-nowrap">
                            {getClassifierText(classifiers?.['EFFORT_ACTIVITY_TYPE'], effortActivityTypeCode)}
                        </p>
                    </LinkWithOrigin>
                    <div style={getTextClampedToLinesProps(1)}>{employeeList}</div>
                    <LineClamp maxLineCount={1} className="text-fg-secondary">
                        {description}
                    </LineClamp>
                </div>
                <HoursDisplay value={usedTimeInSeconds / 3600} />
            </div>
        </div>
    );
};

export default EffortList;
